export default "__VITE_ASSET__IEI0gCRO__"